export default __webpack_public_path__ + "static/media/wildsee_motel.c8aae435.jpg";